import axios from "axios";

import { API } from "./constants";

export const getAuthConfig = (token, config = {}) => ({
  ...config,
  headers: {
    ...(config.headers || {}),
    Authorization: `Bearer ${token}`,
  },
});

export const isRequestCanceled = (error) =>
  error?.code === "ERR_CANCELED" || error?.name === "CanceledError";

export const login = (payload) => axios.post(`${API}/auth/login`, payload);

export const requestPasswordReset = (payload) => axios.post(`${API}/auth/forgot-password`, payload);

export const resetPassword = (payload) => axios.post(`${API}/auth/reset-password`, payload);

export const getCurrentUser = (config) => axios.get(`${API}/auth/me`, config);

export const listTickets = (config) => axios.get(`${API}/tickets`, config);

export const getTicket = (ticketId, config) => axios.get(`${API}/tickets/${ticketId}`, config);

export const createTicket = (formData, token) =>
  axios.post(`${API}/tickets`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });

export const deleteTicket = (ticketId, config) => axios.delete(`${API}/tickets/${ticketId}`, config);

export const addTicketMessage = (ticketId, formData, config) =>
  axios.post(`${API}/tickets/${ticketId}/messages`, formData, config);

export const updateTicketAction = (ticketId, payload, config) =>
  axios.post(`${API}/tickets/${ticketId}/action`, payload, config);

export const updateTicketAssignment = (ticketId, payload, config) =>
  axios.patch(`${API}/tickets/${ticketId}/assignment`, payload, config);

export const downloadTicketAttachment = (ticketId, attachmentId, config) =>
  axios.get(`${API}/tickets/${ticketId}/attachments/${attachmentId}`, {
    ...config,
    responseType: "blob",
  });

export const listNotifications = (config) => axios.get(`${API}/tickets/notifications/list`, config);

export const markNotificationAsRead = (notificationId, config) =>
  axios.patch(`${API}/tickets/notifications/${notificationId}/read`, {}, config);

export const listAdminClients = (config) => axios.get(`${API}/auth/admin/clients`, config);

export const createAdminClient = (payload, config) => axios.post(`${API}/auth/admin/clients`, payload, config);

export const updateAdminClient = (clientId, payload, config) =>
  axios.patch(`${API}/auth/admin/clients/${clientId}`, payload, config);

export const deleteAdminClient = (clientId, config) =>
  axios.delete(`${API}/auth/admin/clients/${clientId}`, config);

export const listAdminDevelopers = (config) => axios.get(`${API}/auth/admin/developers`, config);

export const createAdminDeveloper = (payload, config) =>
  axios.post(`${API}/auth/admin/developers`, payload, config);

export const updateAdminDeveloper = (developerId, payload, config) =>
  axios.patch(`${API}/auth/admin/developers/${developerId}`, payload, config);

export const deleteAdminDeveloper = (developerId, config) =>
  axios.delete(`${API}/auth/admin/developers/${developerId}`, config);
